import { render, staticRenderFns } from "./EntryWorksSwiper.vue?vue&type=template&id=ea2e0186&"
import script from "./EntryWorksSwiper.vue?vue&type=script&lang=js&"
export * from "./EntryWorksSwiper.vue?vue&type=script&lang=js&"
import style0 from "./EntryWorksSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports